module.exports = __webpack_public_path__ + "img/lightwave.c832ed5f.png";